export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    setOccuHeaAdminPartnerInputReadOnly({commit}, contactId) {
        commit('modifyOccuHeaAdminPartnerInputReadOnly', contactId);
    }
}
